/**
 * @generated SignedSource<<16305c740ae60e3998f3c2639ff4f98d>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { ReaderFragment } from 'relay-runtime';
import type { FragmentRefs, Result } from "relay-runtime";
export type useDevDocsAncestorsFragment_content$data = Result<{
  readonly ancestors: ReadonlyArray<{
    readonly history: {
      readonly createdBy: {
        readonly displayName: string | null;
      } | null;
    } | null;
    readonly id: string | null;
    readonly properties: {
      readonly nodes: ReadonlyArray<{
        readonly id: string | null;
        readonly key: string | null;
        readonly value: string | null;
      } | null> | null;
    } | null;
    readonly subType: string | null;
    readonly title: string | null;
    readonly type: string | null;
  } | null> | null;
  readonly id: string | null;
  readonly " $fragmentType": "useDevDocsAncestorsFragment_content";
}, unknown>;
export type useDevDocsAncestorsFragment_content$key = {
  readonly " $data"?: useDevDocsAncestorsFragment_content$data;
  readonly " $fragmentSpreads": FragmentRefs<"useDevDocsAncestorsFragment_content">;
};

const node: ReaderFragment = (function(){
var v0 = {
  "kind": "ScalarField",
  "name": "id"
};
return {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": {
    "catchTo": "RESULT"
  },
  "name": "useDevDocsAncestorsFragment_content",
  "selections": [
    (v0/*: any*/),
    {
      "concreteType": "Content",
      "kind": "LinkedField",
      "name": "ancestors",
      "plural": true,
      "selections": [
        (v0/*: any*/),
        {
          "kind": "ScalarField",
          "name": "title"
        },
        {
          "kind": "ScalarField",
          "name": "type"
        },
        {
          "kind": "ScalarField",
          "name": "subType"
        },
        {
          "concreteType": "History",
          "kind": "LinkedField",
          "name": "history",
          "plural": false,
          "selections": [
            {
              "kind": "LinkedField",
              "name": "createdBy",
              "plural": false,
              "selections": [
                {
                  "kind": "ScalarField",
                  "name": "displayName"
                }
              ]
            }
          ]
        },
        {
          "args": [
            {
              "kind": "Literal",
              "name": "keys",
              "value": [
                "devdocsProperties",
                "smartFolderProperties"
              ]
            }
          ],
          "concreteType": "PaginatedJsonContentPropertyList",
          "kind": "LinkedField",
          "name": "properties",
          "plural": false,
          "selections": [
            {
              "concreteType": "JsonContentProperty",
              "kind": "LinkedField",
              "name": "nodes",
              "plural": true,
              "selections": [
                (v0/*: any*/),
                {
                  "kind": "ScalarField",
                  "name": "key"
                },
                {
                  "kind": "ScalarField",
                  "name": "value"
                }
              ]
            }
          ],
          "storageKey": "properties(keys:[\"devdocsProperties\",\"smartFolderProperties\"])"
        }
      ]
    }
  ],
  "type": "Content"
};
})();

(node as any).hash = "2e1c4ac87bef37baa9997bd2fd844163";

export default node;
